import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  // Scroll reveal observer
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid="layout-root">
      <Navbar />
      <main className="flex-1 pt-24 md:pt-28">
        <Outlet />
      </main>
      <Footer />

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/919941630848?text=Hi%20NGXP%20Technologies%20Team%2C%0A%0AI%20am%20interested%20in%20learning%20more%20about%20your%20services.%20Specifically%2C%20I%20would%20like%20more%20information%20on%3A%0A%0A-%20AI-native%20enterprise%20platforms%0A-%20Operational%20command%20centers%0A-%20Digital%20twin%20monitoring%20systems%0A-%20Computer%20vision%20safety%20systems%0A-%20IoT-connected%20field%20intelligence%20systems%0A-%20XR%20and%20simulation%20training%20platforms%0A-%20Agentic%20AI%20and%20RAG-based%20knowledge%20systems%0A-%20Workflow%20automation%20and%20decision%20intelligence%20dashboards%0A%0ACould%20one%20of%20your%20technology%20consultants%20connect%20with%20me%20to%20understand%20our%20requirements%20and%20explore%20how%20NGXP%20Technologies%20can%20support%20our%20business%3F%0A%0AThank%20you"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        style={{ zIndex: 9999 }}
        className="fixed bottom-6 right-6 w-14 h-14 rounded-full shadow-lg flex items-center justify-center bg-[#25D366] hover:bg-[#20ba5a] transition-transform hover:scale-110 whatsapp-float"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="w-8 h-8 fill-white">
          <path d="M16 0C7.163 0 0 7.163 0 16c0 2.833.742 5.495 2.042 7.8L0 32l8.418-2.01A15.94 15.94 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 0 1-6.771-1.854l-.486-.288-5.002 1.195 1.221-4.87-.317-.5A13.267 13.267 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.29-9.958c-.4-.2-2.363-1.165-2.73-1.299-.367-.133-.634-.2-.9.2-.267.4-1.033 1.299-1.267 1.566-.233.267-.467.3-.867.1-.4-.2-1.688-.622-3.215-1.984-1.188-1.059-1.99-2.367-2.223-2.767-.233-.4-.025-.616.175-.815.18-.178.4-.467.6-.7.2-.233.267-.4.4-.667.133-.267.067-.5-.033-.7-.1-.2-.9-2.166-1.233-2.966-.325-.78-.655-.673-.9-.686l-.767-.013c-.267 0-.7.1-1.067.5s-1.4 1.366-1.4 3.332 1.433 3.866 1.633 4.133c.2.267 2.82 4.3 6.832 6.032.955.413 1.7.66 2.282.844.958.305 1.831.262 2.52.159.769-.114 2.363-.966 2.697-1.899.333-.933.333-1.733.233-1.899-.1-.167-.367-.267-.767-.467z"/>
        </svg>
      </a>
    </div>
  );
}
